// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

// Shown when the session probe could not answer. The wording says nothing
// about being signed out, because nothing here says the visitor is: the
// cookie is untouched and the page they asked for is waiting behind a
// backend that is briefly unreachable.
export const SessionUnavailable = ({ onRetry }: { onRetry: () => void }) => (
  <div
    role="status"
    className="flex flex-col items-center justify-center h-full gap-4 text-center"
  >
    <h1 className="text-2xl font-bold">Reconnecting to Ebiose</h1>
    <p className="text-lg text-neutral-500">
      We can&apos;t reach the server, so your session can&apos;t be confirmed
      right now. You have not been signed out.
    </p>
    <button
      type="button"
      onClick={onRetry}
      className="px-6 py-3 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
    >
      Try again
    </button>
  </div>
)
